// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"15":"83a449fa025ad3156481","32":"93aa8d104e06367680f8","59":"28c458ccf83451631346","399":"d0a19021f2a57d8272c5","838":"49607be311556490735b","852":"0c1096b93af5785adc4d"}[chunkId] + ".js";
};